import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { AbacService } from '../../../core/services/abac.service';
import { commonConstants } from '../../constants/commonConstants';

@Component({
  selector: 'app-common-grid',
  templateUrl: './common-grid.component.html',

})
export class CommonGridComponent implements OnInit {
  @Input() gridList: any;
  @Input() ColumnData: any;
  @Output() editClicked: EventEmitter<object> = new EventEmitter<object>();
  @Output() deleteClicked: EventEmitter<object> = new EventEmitter<object>();

  @ViewChild('grid', { static: true }) grid!: GridComponent;
  public filterSettings!: object;
  public toolbar: string[] = [];
  public pageSettings!: PageSettingsModel;
  edit = false;
  editUser!: number;
  createUser = false;
  addButtonLabel: string = commonConstants.addButtonLabel;

   constructor(public readonly abacService: AbacService) {}

ngOnInit(): void {
  this.filterSettings = { type: commonConstants.filterSettingsType };
  this.toolbar = [ commonConstants.toolbarType ];
  this.pageSettings = { pageSize: commonConstants.pageSettingsCount };
}

onEditStatus(data: object): void {
  this.editClicked.emit(data);  
}

onDeleteStatus(data: object): void {
  this.deleteClicked.emit(data);  
  
}
 
  
}
